export default __webpack_public_path__ + "static/denar-17692a2e4b0068db1ba3c9d5f0ea9216.png";